import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const CalendarWeekHeader = ({ 
  weekDates,
  cellWidth = 100,
  hourHeight = 80,
  hideWeekends = false,
  backgroundColor = 'rgb(245,245,250)',
  dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
}) => {
  if (!weekDates || ![7,5].includes(weekDates.length)) return null;
  const _weekDates = (
    hideWeekends
    ? weekDates.filter((d, i) => ![0,6].includes(d.getDay()))
    : weekDates
  );
  const _dayNames = (
    hideWeekends 
    ? dayNames.filter((d, i) => ![0,6].includes(i))
    : dayNames
  );
  // const totalWidth = cellWidth * _weekDates.length + cellWidth;
  return (
    <Box
      sx={{
        display: 'flex',
        flexShrink: 0,
        borderBottom: 1,
        height: hourHeight,
        borderColor: 'divider',
        backgroundColor: 'background.paper',
        width: cellWidth * (hideWeekends ? 5 : 7) + 1,
      }}
    >
      <Box
        sx={{
          width: cellWidth,  
          height: '100%',
          flexShrink: 0,
          borderRight: 1,
          borderColor: 'divider',
          backgroundColor,
        }}
      />
      {_weekDates.map((date, i) => (
        <Box
          key={date.toISOString()}
          style={{
            width: cellWidth,
            height: '100%',
            backgroundColor,
            flexShrink: 0,
            // paddingTop: '1em',
            // paddingBottom: '1em',
          }}
          sx={{
            // flexShrink: 0,
            // py: 1,
            // px: 0.5,
            borderRight: 1,
            borderColor: 'divider',
            // textAlign: 'center',
            // textJustify: 'center',
          }}
        >
          <Stack 
            direction="column" 
            alignItems="center" 
            justifyContent='center' 
            spacing={0.05}
            style={{ height: '100%' }}
          >
            <Typography 
              variant="caption" 
              display="block" 
              color="text.grey.800"
              // color="text.secondary" 
              fontWeight={600}
            >
              {_dayNames[i].slice(0, 3)}
            </Typography>
            <Typography variant="body1" color='text.muted' fontWeight={500}>
              {date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
            </Typography>

          </Stack>
        </Box>
      ))}
    </Box>
  );
};

export default CalendarWeekHeader;
